// Navigation targets can arrive from outside the app — email links carrying `redirectUrl`, `returnUrl` query
// parameters — so they have to be proven same-origin before being handed to `navigate()`.
// Matching prefixes is not enough: "/\evil.com" starts with a single slash, yet URL parsing normalizes the
// backslash to a slash and resolves it to https://evil.com/. Tabs and newlines are stripped during parsing and
// hide the same trick. Resolving the path is the only check that sees what the browser will actually do.
export function isValidInternalPath(path: string | null): boolean {
    if (!path) {
        return false;
    }

    if (!path.startsWith("/")) {
        return false;
    }

    return new URL(path, window.location.origin).origin === window.location.origin;
}
